"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedRequest = void 0;
const core = __importStar(require("../../../core"));
const EmbedRequestInput_1 = require("../../types/EmbedRequestInput");
const EmbedRequestInputType_1 = require("../../types/EmbedRequestInputType");
exports.EmbedRequest = core.serialization.object({
    input: EmbedRequestInput_1.EmbedRequestInput,
    model: core.serialization.string(),
    inputType: core.serialization.property("input_type", EmbedRequestInputType_1.EmbedRequestInputType.optional()),
    truncation: core.serialization.boolean().optional(),
    encodingFormat: core.serialization.property("encoding_format", core.serialization.stringLiteral("base64").optional()),
});
